@charset "UTF-8";

/* src/app/forms/query-executor/query-executor.component.scss */
.query-main {
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: auto;
}
.query-spin {
  height: 100%;
  display: block;
}
:host ::ng-deep .query-spin > .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.query-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--tem-space-2);
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border-bottom: 1px solid var(--tem-border);
}
.flex-spacer {
  flex-grow: 1;
}
.hdivider {
  margin: 0;
}
.full-width {
  width: 100%;
}
.object-list {
  display: flex;
  flex-direction: column;
}
.object-inactive {
  color: var(--tem-danger);
}
.object-name:hover {
  background: var(--tem-accent-soft);
}
.query-text-area,
.object-view-text {
  height: 100%;
  resize: none;
}
.object-view-text {
  white-space: pre;
  font-family: monospace;
}
.menu-label {
  margin-left: var(--tem-space-2);
}
.query-text {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 6px;
  gap: 10px;
  margin-top: 10px;
}
.object-name {
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  height: 30px;
  align-content: center;
  padding-left: 10px;
  cursor: pointer;
}
.query-result {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 6px;
}
.query-object-item {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.query-object-item-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
  padding-top: 10px;
}
.query-object-item-list-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.query-object-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
:host ::ng-deep .ant-splitter-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.query-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.query-object-item {
  display: flex;
  height: 100%;
  overflow: auto;
}
.action-image-buttons {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 4px;
}
.query {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
}
.message {
  color: var(--tem-muted);
  border-bottom: 1px solid var(--tem-border);
  font-weight: 500;
}
.messages {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.tabs {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
.fechar {
  margin-left: 10px;
  font-size: 14px;
  color: var(--tem-muted);
}
.fechar:hover {
  color: var(--tem-danger);
}
.tab {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 10px;
}
.tab-name {
  display: flex;
  flex-direction: row;
  gap: 3px;
  position: relative;
}
.tab-name-btn {
  color: var(--tem-deep);
}
.fill-container {
  height: 100%;
}
.NgxEditor {
  height: 100%;
}
.tabs-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
}
nz-tabs {
  height: 100%;
}
:host ::ng-deep .ant-tabs-content,
:host ::ng-deep .ant-tabs-tabpane {
  height: 100%;
}
.negative-class {
  margin-right: -13px;
}
/*# sourceMappingURL=query-executor.component.css.map */
